/**
 * URL Porams (optional):
 *  a11yc - Contrast mode, set to activate
 *  a11yfs - Font size, set to 1-3, e.g. a11yfs=2
 *
 *  26.04.30 - 1v6
 *      - added noUrlParam option, if set to true, no url params will be set
 *      - added minFontSize and maxFontSize options
 *  26.02.25 - 1v5
 *      - added onSizeChangeCallback
 *      - code refactoring and cleanup
 *  26.02.10 - 1v1
 *      - added debug output
 *  25.12.30 - 1v0
 *      - initial version
 *
 */

import Cookies from 'js-cookie';

class LeA11y {

    constructor( config ) {

        const settings_default = {
            button_selector_base: '.rt-a11y-item',
            debug: false,
            onSizeChangeCallback: null,
            noUrlParam: true,
            minFontSize: 1,
            maxFontSize: 3
        }

        this.settings = {
            ...settings_default,
            ...config
        }

        if (this.settings.debug === true) this.debug = true;

        if (this.debug) console.log('LeA11y: constructor( config ) > config = ', config);

        // store in global window object to make it accessible from outside
        window.a11y_font_size_max = this.settings.maxFontSize;
        window.a11y_font_size_min = this.settings.minFontSize;

        this.getCookieSettings();

        this.getUrlParamSettings();

        this.setUrlParamSettings();

    }

    getCookieSettings() {
        this.iz_contrast = Cookies.get('a11y_contrast') ?? false;
        this.fontsize_iz = Cookies.get('a11y_fontsize') ? parseInt( Cookies.get('a11y_fontsize') ) : 1 ;
        if (this.debug) console.log('LeA11y: getCookieSettings() - iz_contrast, fontsize_iz > ', this.iz_contrast, this.fontsize_iz);
    }

    getUrlParamSettings() {
        let params = new URLSearchParams(document.location.search);
        if (params.get("a11yc") !== null) this.iz_contrast = 'true';
        if (params.get("a11yfs") !== null) this.fontsize_iz = parseInt( params.get("a11yfs") );

        if (this.fontsize_iz > window.a11y_font_size_max) this.fontsize_iz = window.a11y_font_size_max;

        if (this.debug) console.log('LeA11y: getUrlParamSettings() - iz_contrast, fontsize_iz > ', this.iz_contrast, this.fontsize_iz);

    }

    setUrlParamSettings() {

        if (this.settings.noUrlParam) {
            if (this.debug) console.log('LeA11y: setUrlParamSettings() > NARP! noUrlParam izz');
            return;
        }

        let params = new URLSearchParams(document.location.search);

        if (this.iz_contrast == 'true' || this.iz_contrast == true) {
            params.set("a11yc", this.iz_contrast);
        } else {
            params.delete("a11yc");
        }
        params.set("a11yfs", this.fontsize_iz);
        window.history.replaceState({}, "", "?" + params);

        if (this.debug) console.log('LeA11y: setUrlParamSettings()', params);
    }

    _changeSize( smaller = true ) {
        let curr_size = parseInt( document.querySelector('html').getAttribute('data-a11y-font-size') );
        if ( ( smaller && (curr_size > window.a11y_font_size_min) ) ||
            (!smaller && (curr_size < window.a11y_font_size_max) ) ) {

            document.querySelector('html').classList.remove('-a11y-font-size-' + curr_size);
            curr_size += smaller ? -1 : 1;
            document.querySelector('html').classList.add('-a11y-font-size-' + curr_size);
            document.querySelector('html').setAttribute('data-a11y-font-size', '' + curr_size);

            Cookies.set('a11y_fontsize', curr_size, { expires: 365 });

            this.fontsize_iz = curr_size;

            if (this.debug) console.log('LeA11y: _changeSize('+(smaller ? ' smaller ' : ' bigger ')+') > cookies "a11y_fontsize" set to ', this.fontsize_iz );
        }

        if (curr_size == window.a11y_font_size_min) {

        }

        if (curr_size == window.a11y_font_size_max) {

        }

        if (this.settings.onSizeChangeCallback) {
            this.settings.onSizeChangeCallback( curr_size );
        }

        this.setUrlParamSettings();
    }

    init() {
        if (this.debug) console.log('LeA11y: init()');

        // CONTRAST
        if (this.iz_contrast == 'true') document.querySelector('html').classList.add('-a11y-contrast');
        const a11y_contrast = document.querySelectorAll(this.settings.button_selector_base + '.-contrast');
        if (a11y_contrast) {
            a11y_contrast.forEach( (ele, ind) => {

                // ele.removeEventListener();
                ele.addEventListener('click', () => {
                    document.querySelector('html').classList.toggle('-a11y-contrast');
                    document.querySelector(this.settings.button_selector_base + '.-contrast').classList.toggle('-active');

                    this.iz_contrast = document.querySelector('html').classList.contains('-a11y-contrast');

                    Cookies.set('a11y_contrast', this.iz_contrast , { expires: 365 });

                    if (this.debug) console.log('LeA11y: init() > cookies "a11y_contrast" set to ', this.iz_contrast );

                    this.setUrlParamSettings();
                });

            });
        }

        document.querySelector('html').classList.add('-a11y-font-size-' + this.fontsize_iz);
        document.querySelector('html').setAttribute('data-a11y-font-size', this.fontsize_iz);

        // FONT SIZE > SMALLER
        const a11y_font_smaller = document.querySelectorAll(this.settings.button_selector_base + '.-font-minus');
        if (a11y_font_smaller) {
            a11y_font_smaller.forEach( (ele, ind ) =>  {

                // ele.removeEventListener();
                ele.addEventListener('click', () => {
                    this._changeSize( true )
                });

            });
        }

        // FONT SIZE > LARGER
        const a11y_font_larger = document.querySelectorAll(this.settings.button_selector_base + '.-font-plus');
        if (a11y_font_larger) {
            a11y_font_larger.forEach( (ele, ind) => {

                // ele.removeEventListener();
                ele.addEventListener('click', () => {
                    this._changeSize( false )
                });

            });
        }

    }

}

export default LeA11y;